import { createContext, useContext, useState } from 'react';

/**
 * MockTenantProvider - Simulates TenantContext for UI testing
 * 
 * IMPORTANT: This is ONLY for UI Harness mode
 * Provides mock business and user data for UI rendering
 */

const MockTenantContext = createContext(null);

// Export hook with same name as real context
export function useTenant() {
  return useContext(MockTenantContext);
}

export function MockTenantProvider({ children, scenario = 'default' }) {
  const [loading] = useState(false);
  const [error] = useState(null);

  // Mock scenarios for different testing states
  const scenarios = {
    default: {
      user: {
        id: 'user_123',
        clerk_user_id: 'clerk_123',
        email: 'owner@testbusiness.com',
        first_name: 'John',
        last_name: 'Doe',
        role: 'owner',
        business_id: 'biz_123',
      },
      business: {
        id: 'biz_123',
        name: 'Test Restaurant',
        slug: 'test-restaurant',
        email: 'contact@testbusiness.com',
      },
      has_business: true,
      wallet_id: 'wallet_123',
    },
    'new-user': {
      user: null,
      business: null,
      has_business: false,
      wallet_id: null,
    },
    'low-balance': {
      user: {
        id: 'user_456',
        clerk_user_id: 'clerk_456',
        email: 'low@balance.com',
        first_name: 'Jane',
        last_name: 'Smith',
        role: 'owner',
        business_id: 'biz_456',
      },
      business: {
        id: 'biz_456',
        name: 'Low Balance Cafe',
        slug: 'low-balance-cafe',
        email: 'cafe@lowbalance.com',
      },
      has_business: true,
      wallet_id: 'wallet_456',
    },
  };

  const tenant = scenarios[scenario] || scenarios.default;

  const refreshTenant = async () => {
    console.log('[UI Harness] Mock refresh tenant');
  };

  const getToken = async () => 'mock_token';

  const value = {
    tenant,
    loading,
    needsOnboarding: !tenant.has_business,
    error,
    refreshTenant,
    getToken,
  };

  return (
    <MockTenantContext.Provider value={value}>
      {children}
    </MockTenantContext.Provider>
  );
}
